import { GlSprintf } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { s__ } from '~/locale';
const timeSpent = s__('TimeTracking|%{spentStart}Spent: %{spentEnd}');
export default {
    name: 'TimeTrackingSpentOnlyPane',
    timeSpent,
    components: {
        GlSprintf
    },
    props: {
        timeSpentHumanReadable: {
            type: String,
            required: true
        }
    }
};
